import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const DotCircleArrows: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path d="M25.778 8H36.9v4h-3.454c3.83 2.59 6.332 7.051 6.332 12.088 0 6.884-4.686 12.71-11.045 14.12l-.866-3.904c4.473-.992 7.911-5.15 7.911-10.216 0-4.315-2.492-7.973-6-9.575V19.4h-4V8ZM10.9 36.4h3.207C10.575 33.767 8.3 29.488 8.3 24.686c0-7.102 4.99-13.082 11.657-14.242l.686 3.94C15.96 15.2 12.3 19.457 12.3 24.686c0 4.314 2.493 7.973 6 9.575V29.4h4v11H10.9v-4Z" />
  );

  const normalHover = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.93 4.858 21.226 7.87l3.086 10.974 3.85-1.082-1.323-4.706c3.81.593 7.2 3.44 8.369 7.593 1.371 4.877-.813 9.81-4.85 11.976l1.89 3.525c5.74-3.08 8.674-9.957 6.81-16.584-1.363-4.848-4.98-8.465-9.367-9.921l3.324-.935-1.083-3.85ZM17.679 38.366l-3.087.868 1.083 3.85 10.974-3.086L23.67 29.41l-3.85 1.083 1.315 4.68c-3.81-.593-7.2-3.44-8.368-7.594-1.415-5.033.956-10.123 5.243-12.175l-1.727-3.608c-6.105 2.922-9.29 10.03-7.366 16.866 1.3 4.623 4.648 8.127 8.76 9.705Z"
    />
  );

  return getIcon({ size, isHovered, normal, normalHover });
};

export default DotCircleArrows;
